import DomTree from '../DevTool/components/Layout/DomTree';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import dtMixin from "../DevTool/util/devToolMixin";
import { INJECT_UICORE_BUS } from '../../utils/consts';
const __script_base__ = {
  name: 'PageDom',
  props: {
    layout: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  mixins: [dtMixin],
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    },
    ucBus: {
      from: INJECT_UICORE_BUS,
      default: null
    }
  },
  components: {
    DomTree
  },
  created() {
    this.uc = this.ucBus;
  },
  methods: {
    openDevTool() {
      this.designer.openDevtool();
    },
    toggleCnName(e) {
      this.$set(this.bus.options, 'showCnName', e.target.checked);
    },
    toggleDomActions(e) {
      this.$set(this.bus.options, 'showActions', e.target.checked);
    },
    handleTreeKeyDown(ev) {
      const keyCode = ev.which || ev.keyCode;
      if (keyCode === 46 || keyCode === 8) {
        this.designer.deleteActiveComp();
        ev.preventDefault();
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-dom"
  }, [_c("div", {
    staticClass: "ucd-dom-opts"
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.bus.options.showCnName
    },
    on: {
      change: _vm.toggleCnName
    }
  }, [_c("span", {
    style: {
      color: "#f0f0f0"
    }
  }, [_vm._v(" 显示中文名\n      ")])])], 1), _vm._v(" "), _c("DomTree", {
    style: {
      height: "100%"
    },
    attrs: {
      "hide-actions": true,
      "from-aside": true
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/DomTree/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);